import { toast as hotToast } from 'react-hot-toast';
import { Check, X, AlertTriangle, Info, Loader2 } from 'lucide-react';


const icons = {
  success: (
    <div className="flex items-center justify-center size-7 sm:size-8 rounded-full bg-emerald-500 shadow-sm shrink-0 text-white stroke-[3]">
      <Check className="h-4 w-4 sm:h-5 sm:w-5" />
    </div>
  ),
  error: (
    <div className="flex items-center justify-center size-7 sm:size-8 rounded-full bg-rose-500 shadow-sm shrink-0 text-white stroke-[3]">
      <X className="h-4 w-4 sm:h-5 sm:w-5" />
    </div>
  ),
  warning: (
    <div className="flex items-center justify-center size-7 sm:size-8 rounded-full bg-orange-500 shadow-sm shrink-0 text-white stroke-[3]">
      <AlertTriangle className="h-4 w-4 sm:h-5 sm:w-5" />
    </div>
  ),
  info: (
    <div className="flex items-center justify-center size-7 sm:size-8 rounded-full bg-blue-500 shadow-sm shrink-0 text-white stroke-[3]">
      <Info className="h-4 w-4 sm:h-5 sm:w-5" />
    </div>
  ),
  loading: (
    <div className="flex items-center justify-center size-7 sm:size-8 rounded-full bg-blue-500 shadow-sm shrink-0 text-white stroke-[3]">
      <Loader2 className="h-4 w-4 sm:h-5 sm:w-5 animate-spin" />
    </div>
  )
};

const toastProxy = {
  success: (message: string, duration?: number) => {
    hotToast.success(message, { icon: icons.success, duration });
  },
  error: (message: string, duration?: number) => {
    hotToast.error(message, { icon: icons.error, duration });
  },
  warning: (message: string, duration?: number) => {
    hotToast(message, { icon: icons.warning, duration });
  },
  info: (message: string, duration?: number) => {
    hotToast(message, { icon: icons.info, duration });
  },
  promise: <T,>(
    promiseFn: Promise<T> | (() => Promise<T>),
    msgs: { loading: string; success: string | ((data: T) => string); error: string | ((err: any) => string) }
  ) => {
    const p = typeof promiseFn === 'function' ? promiseFn() : promiseFn;
    hotToast.promise(p, {
      loading: msgs.loading,
      success: msgs.success,
      error: msgs.error
    }, {
      success: { icon: icons.success },
      error: { icon: icons.error },
      loading: { icon: icons.loading }
    });
    return p;
  }
};

export const useToast = () => {
  return toastProxy;
};
